import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import CaseStudySpotless from "@/pages/CaseStudySpotless";

export const Route = createFileRoute("/pl/case-studies/spotless-polska")({
  head: () => routeHead("Case study Spotless Polska — AGAPE", META_DESCRIPTIONS.spotless.pl, "/pl/case-studies/spotless-polska"),
  component: CaseStudySpotless,
});
